/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_all = /** @type {(inputs: {}) => string} */ () => {
	return `Todos`
};

const en_common_all = /** @type {(inputs: {}) => string} */ () => {
	return `All`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_all = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_all(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_all", locale)
	if (locale === "es") return es_common_all(inputs)
	return en_common_all(inputs)
};
export { common_all as "common.all" }